var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',[_c('DatePicker',{attrs:{"disabled":_vm.disabled,"append-icon":"","show-weekends":"","start-date":_vm.startDate,"text-field-activator":"","picker-date":_vm.internalPickerDate,"date-format":"DD/MM/YYYY","date-format-return":"DD/MM/YYYY","mask":!_vm.isIE,"vuetify-options":{
			textField: {
				placeholder: 'JJ/MM/AAAA',
				hint: null,
				solo: true,
				flat: true,
				rules: _vm.datePickerRules,
				clearable: true,
				disabled: _vm.disabled
			},
			datePicker: {
				min: _vm.dateMin,
				max: _vm.dateMax,
				weekdayFormat: _vm.getWeekday,
				disabled: _vm.disabled
			},
			menu: {
				nudgeBottom: 50,
				nudgeRight: -50,
				allowOverflow: true,
				disabled: _vm.disabled
			},
			btn: {
				ripple: true,
				class: 'mt-0 pl-1',
				disabled: _vm.disabled
			}
		}},on:{"update:pickerDate":function($event){_vm.internalPickerDate=$event},"update:picker-date":function($event){_vm.internalPickerDate=$event},"error":_vm.resetInternalPickerDate},scopedSlots:_vm._u([{key:"append-icon",fn:function(){return [_c('CustomIcon',{attrs:{"icon":"calendar","medium":""}})]},proxy:true}]),model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }